import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

//models
import {SlxAdminCustomerModel} from '../model/slx-admin-customer.model';

// service
import {CustomHttp} from '../../core/http-custom/http-custom.service';
import {HttpParams} from '@angular/common/http';

@Injectable()
export class SlxAdminCustomersService {

  private _searchTerm: string;

  constructor(private _http: CustomHttp) {
  }

  public searchCustomers(searchParams: HttpParams): Observable<Array<SlxAdminCustomerModel>> {
    return this._http.get('/apps/umng/customer', null, searchParams);
  }

  public loadAssignedCountries(): Observable<Array<SlxAdminCustomerModel>> {
    return this._http.get('/apps/umng/api/user/assignedCountries');
  }

}
